const tenantSlugPattern = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export const statusTenantSlugFromSearch = (search: string): string | null | undefined => {
  const values = new URLSearchParams(search).getAll('tenant');
  if (values.length === 0) return null;
  if (values.length !== 1 || !tenantSlugPattern.test(values[0])) return undefined;
  return values[0];
};

export const buildStatusLoginUrl = (
  returnUrl: string,
  opts?: { kiosk?: boolean; tenant?: string | null }
) => {
  const params = new URLSearchParams();
  if (returnUrl) {
    params.set('return_url', returnUrl);
  }
  if (opts?.kiosk) {
    params.set('kiosk', '1');
  }
  if (opts?.tenant && tenantSlugPattern.test(opts.tenant)) {
    params.set('tenant', opts.tenant);
  }
  const query = params.toString();
  return query ? `/api/v1/auth/login?${query}` : '/api/v1/auth/login';
};
